module.exports = __webpack_public_path__ + "media/small.1b731c6c.jpg";